import { observer } from 'mobx-react'
import { forwardRef } from 'react'
import { Block, Heading, IconCheckCircleFilled } from 'suomifi-ui-components'
import LocalizedString, {
  LocalizedParagraphs,
} from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import AetFinallyBackToLandingPage from 'todistukset-ui/src/vtj/components/order-wizard-aet-shared/AetFinallyBackToLandingPage'
import GiveFeedbackInfo from 'todistukset-ui/src/vtj/components/order-wizard-aet-shared/GiveFeedbackInfo'
import { FormContainer } from 'todistukset-ui/src/vtj/components/order-wizard-aet-signer/AetSignerTodistuspyyntoRejectedStep.sc'

import type { StepComponent } from 'todistukset-ui/src/vtj/components/order-wizard/OrderWizardStep.type'
import { useTodistusTheme } from 'todistukset-ui/src/vtj/components/theme/useTodistusTheme'

const AetSignerTodistuspyyntoRejectedStep: StepComponent = observer(
  forwardRef(function AetSignerTodistuspyyntoRejectedStep({ titleId }, _ref) {
    const {
      colors: { successDark1 },
    } = useTodistusTheme()

    return (
      <FormContainer>
        <Block variant="section">
          <Heading variant="h2" id={titleId}>
            <IconCheckCircleFilled color={successDark1} />
            <LocalizedString stringKey="aetSignerTodistuspyyntoRejectedMainTitle" />
          </Heading>
          <LocalizedParagraphs stringKey="aetSignerTodistuspyyntoRejectedDescription_paragraphs" />
        </Block>
        <GiveFeedbackInfo />
        <AetFinallyBackToLandingPage descriptionStringKey="aetFinallyBackToLandingPageDescription" />
      </FormContainer>
    )
  })
)

export default AetSignerTodistuspyyntoRejectedStep
